<!--
 * @Author: yusha
 * @Date: 2023-07-14 14:20:54
 * @LastEditors: yusha
 * @LastEditTime: 2023-07-20 10:30:55
 * @Description: 
-->
<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane v-for="item in comList" :key="item.name" :label="item.title" :name="item.name">
        <div style="border: 1px solid #E4E7ED;border-top: none; padding: 10px;border-radius: 0 0 6px 6px">
          <component :is="item.name" :name="item.name" v-if="activeName == item.name"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import fbaShip from './fbaShip'
import largeBagShip from './largeBagShip'
import smallBagShip from './smallBagShip'

export default {
  // 发票制作列表
  name: "ManufacturableInvoiceList",
  components: {
    fbaShip,
    largeBagShip,
    smallBagShip
  },
  data() {
    return {
      activeName: fbaShip.name,
      forwarder:[],
    }
  },
  computed: {
    comList: function () {
      return [fbaShip, largeBagShip, smallBagShip]
    }
  },
}
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
</style>